export default "<ng4-loading-spinner></ng4-loading-spinner>\r\n\r\n<router-outlet></router-outlet>"